module.exports = __webpack_public_path__ + "static/media/mob_footer_background.58a0ae9b.svg";